import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    companyDetails: null,
    themeColor: "#2563eb",
    companyLogo: null,
    companyName: "FlxFlow",
    isLoading: false,
    error: null
};

const companySlice = createSlice({
    name: "company",
    initialState,
    reducers: {
        setCompanyDetails: (state, action) => {
            state.companyDetails = action.payload;
        },
        setThemeColor: (state, action) => {
            state.themeColor = action.payload;
        },
        setCompanyLogoUrl: (state, action) => {
            state.companyLogo = action.payload;
        },
        setCompanyName: (state, action) => {
            state.companyName = action.payload;
        },
        setCompanyLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setCompanyError: (state, action) => {
            state.error = action.payload;
        },
        clearCompanyDetails: (state) => {
            state.companyDetails = null;
            state.themeColor = "#2563eb";
            state.companyLogo = null;
            state.companyName = "FlxFlow";
            state.isLoading = false;
            state.error = null;
        }
    }
});

export const {
    setCompanyDetails,
    setThemeColor,
    setCompanyLogoUrl,
    setCompanyName,
    setCompanyLoading,
    setCompanyError,
    clearCompanyDetails
} = companySlice.actions;

export default companySlice.reducer;
